export default {
  name: 'client-data',
  props: {
    client: {
      requred: true
    }
  },

  methods: {
    clientUpdate() {
      const { id: clientId, name, address, contact_email } = this.client;

      const updatePromise = this.$store.dispatch('clientUpdate', {
        clientId,
        payload: { name, address, contact_email }
      });

      updatePromise.then(
        () => {
          this.flashSuccess('Данные о клиенте обновлены');
        },
        error => {
          this.flashError('Не удалось сохранить данные о клиенте');
          console.error(error);
        }
      );
      return updatePromise;
    },

    clickEmailButton() {
      this.$emit('email', {
        id: this.client.id,
        email: this.client.contact_email
      });
    },

    clickSmsButton() {
      this.$emit('sms');
    }
  }
};
